export const AI_LEASING_FIELDS = {
  IS_CHAT_ENABLED: 'is_chat_enabled',
  IS_SMS_ENABLED: 'is_sms_enabled',
  IS_AI_EMAIL_ENABLED: 'ai_email_enabled',
  IS_VOICE_ENABLED: 'is_voice_enabled',
  IS_AI_NURTURE_ENABLED: 'is_ai_nurture_enabled',
  PNA_VA_ENABLED: 'pna_va_enabled',
  SCHEDULE_TOUR_VA_ENABLED: 'schedule_tour_va_enabled',
};

export const AI_LEASING_COLUMN_NAMES = {
  [AI_LEASING_FIELDS.IS_CHAT_ENABLED]: 'Chat',
  [AI_LEASING_FIELDS.IS_SMS_ENABLED]: 'SMS',
  [AI_LEASING_FIELDS.IS_AI_EMAIL_ENABLED]: 'Email',
  [AI_LEASING_FIELDS.IS_VOICE_ENABLED]: 'Voice',
  [AI_LEASING_FIELDS.IS_AI_NURTURE_ENABLED]: 'Nurture',
  [AI_LEASING_FIELDS.PNA_VA_ENABLED]: 'P&A Flow',
  [AI_LEASING_FIELDS.SCHEDULE_TOUR_VA_ENABLED]: 'Schedule Tour Flow',
};

export const AI_LEASING_TOOL_TIPS = {
  [AI_LEASING_FIELDS.IS_CHAT_ENABLED]:
    'Activates AI on existing Knockbot widget',
  [AI_LEASING_FIELDS.IS_SMS_ENABLED]: 'Activates AI SMS',
  [AI_LEASING_FIELDS.IS_AI_EMAIL_ENABLED]: 'Activates AI Email',
  [AI_LEASING_FIELDS.IS_VOICE_ENABLED]: 'Activates AI Voice',
  [AI_LEASING_FIELDS.IS_AI_NURTURE_ENABLED]: 'Activates AI Nurture',
  [AI_LEASING_FIELDS.PNA_VA_ENABLED]:
    'Controls whether AI will quote Pricing & Availability. If disabled, VA will collect info and make a note for the site staff to contact the prospect',
  [AI_LEASING_FIELDS.SCHEDULE_TOUR_VA_ENABLED]: 'Controls whether AI will send Schedule Tour link.  If disabled, VA will collect info and make a note for the site staff to contact the prospect',
};

export const AI_RESIDENT_FIELDS = {
  RESIDENT_VIRTUAL_AGENT_SMS: 'resident_virtual_agent_sms',
  RESIDENT_VIRTUAL_AGENT_VOICE: 'resident_virtual_agent_voice',
  RESIDENT_VIRTUAL_AGENT_CHAT: 'resident_virtual_agent_chat',
  RESIDENT_VIRTUAL_AGENT_EMAIL: 'resident_virtual_agent_email',
  IS_RESIDENT_AI_NURTURE_ENABLED: 'is_resident_ai_nurture_enabled',
};

export const AI_RESIDENT_COLUMN_NAMES = {
  [AI_RESIDENT_FIELDS.RESIDENT_VIRTUAL_AGENT_SMS]: 'SMS',
  [AI_RESIDENT_FIELDS.RESIDENT_VIRTUAL_AGENT_VOICE]: 'Voice',
  [AI_RESIDENT_FIELDS.RESIDENT_VIRTUAL_AGENT_CHAT]: 'Chat',
  [AI_RESIDENT_FIELDS.RESIDENT_VIRTUAL_AGENT_EMAIL]: 'Email',
  [AI_RESIDENT_FIELDS.IS_RESIDENT_AI_NURTURE_ENABLED]: 'Nurture',
};

export const AI_RESIDENT_TOOL_TIPS = {
  [AI_RESIDENT_FIELDS.RESIDENT_VIRTUAL_AGENT_SMS]: 'Enables AI SMS for resident inquiries',
  [AI_RESIDENT_FIELDS.RESIDENT_VIRTUAL_AGENT_VOICE]:
    'Enables AI Voice for resident inquiries',
  [AI_RESIDENT_FIELDS.RESIDENT_VIRTUAL_AGENT_CHAT]:
    'Enables AI Chat for resident inquiries',
  [AI_RESIDENT_FIELDS.RESIDENT_VIRTUAL_AGENT_EMAIL]:
    'Enables AI Email for resident inquiries',
  [AI_RESIDENT_FIELDS.IS_RESIDENT_AI_NURTURE_ENABLED]: 'Activates Resident AI Nurture',
};

export const GENERAL_SETTINGS_FIELDS = {
  ANSWER_VERIFICATION: 'is_answer_verification',
  CALL_ROUTING: 'call_routing',
  RESIDENT_CALL_ROUTING: 'resident_call_routing',
  CHAT_ROLLOVER: 'chat_rollover',
  OFFER_TIMES: 'offer_time',
  RPCC_AGENT_ROLLOVER: 'rpcc_agent_rollover',
};

export const GENERAL_SETTINGS_COLUMN_NAMES = {
  [GENERAL_SETTINGS_FIELDS.ANSWER_VERIFICATION]: 'Answer Verification',
  [GENERAL_SETTINGS_FIELDS.CALL_ROUTING]: 'Call Routing',
  [GENERAL_SETTINGS_FIELDS.RESIDENT_CALL_ROUTING]: 'Resident Call Routing',
  [GENERAL_SETTINGS_FIELDS.CHAT_ROLLOVER]: 'RPCC Chat Rollover',
  [GENERAL_SETTINGS_FIELDS.OFFER_TIMES]: 'Ring Time',
  [GENERAL_SETTINGS_FIELDS.RPCC_AGENT_ROLLOVER]: 'RPCC Voice Rollover',
};

export const GENERAL_SETTINGS_TOOL_TIPS = {
  [GENERAL_SETTINGS_FIELDS.ANSWER_VERIFICATION]:
    'Only applies to Missed Calls. Used only as necessary depending on the property’s telephony setup',
  [GENERAL_SETTINGS_FIELDS.CALL_ROUTING]:
    'Setting to All Calls will route all incoming prospect calls to AI. Setting to Missed Calls will route only missed prospect calls to AI',
  [GENERAL_SETTINGS_FIELDS.RESIDENT_CALL_ROUTING]:
    'Routes incoming resident calls to AI, independent of leasing call routing. After Hours routes resident calls to AI only outside of office hours',
  [GENERAL_SETTINGS_FIELDS.CHAT_ROLLOVER]:
    'Requires a RPCC order. Enables chats to transfer to RPCC',
  [GENERAL_SETTINGS_FIELDS.OFFER_TIMES]:
    'Only applies to Missed Calls. The length of time a call will ring to the property before transferring to AI',
  [GENERAL_SETTINGS_FIELDS.RPCC_AGENT_ROLLOVER]:
    'Requires a RPCC order. Enables calls to transfer to RPCC',
};

export const CALL_ROUTING = [
  {
    label: 'All',
    value: 'ALL',
  },
  {
    label: 'Missed',
    value: 'MISSED_CALLS',
  },
  {
    label: 'Off',
    value: 'OFF',
  },
];

export const RESIDENT_CALL_ROUTING = [
  {
    label: 'All',
    value: 'ALL',
  },
  {
    label: 'Missed',
    value: 'MISSED_CALLS',
  },
  {
    label: 'After Hours',
    value: 'AFTER_HOURS',
  },
  {
    label: 'Off',
    value: 'OFF',
  },
];
